import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  DoppiaMaterialitaService,
  DoppiaSurvey,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { NgStarRatingService } from 'src/app/services/ng-star-rating/ng-star-rating.service';

@Component({
  selector: 'app-anteprima-doppia-materialita-suvey',
  standalone: false,

  templateUrl: './anteprima-doppia-materialita-suvey.component.html',
  styleUrl: './anteprima-doppia-materialita-suvey.component.scss',
})
export class AnteprimaDoppiaMaterialitaSuveyComponent implements AfterViewInit {
  public dataCompilazione: string = '';
  public tipoPunteggio: number = 0;
  private _datiSurvey: DoppiaSurvey | undefined = undefined;
  private _landingPage: SafeHtml = '';
  private _idSurveyCompilato: string = '';
  public infoElemento: string = 'NESSUNA INFORMAZIONE';

  public etichetteESRS: { [idTema: string]: string } | undefined = {};

  @Input()
  set datiSurvey(datiSurvey: DoppiaSurvey) {
    this._datiSurvey = JSON.parse(JSON.stringify(datiSurvey)) as DoppiaSurvey;
    this.etichetteESRS = this._doppiaMaterialitaService.creaEtichettaESRS(this._datiSurvey);
  }
  get datiSurvey() {
    return this._datiSurvey!;
  }

  @Input()
  set landingPage(_landingPage: string) {
    this._landingPage = this.sanitizer.bypassSecurityTrustHtml(_landingPage || '');
  }
  get landingPage(): SafeHtml {
    return this._landingPage;
  }

  @Input()
  set idSurveyCompilato(_idSurveyCompilato: string) {
    this._idSurveyCompilato = _idSurveyCompilato;
  }
  get idSurveyCompilato() {
    return this._idSurveyCompilato;
  }

  constructor(
    public ngStarRating: NgStarRatingService,
    private readonly sanitizer: DomSanitizer,
    private readonly cdRef: ChangeDetectorRef,
    private readonly _doppiaMaterialitaService: DoppiaMaterialitaService,
  ) {}

  ngAfterViewInit(): void {
    this.datiIniziali();
    this.cdRef.detectChanges();
  }

  public datiIniziali() {
    //data compilazione
    if (this._datiSurvey?.dataCompilazione) {
      // Creare un oggetto Date dal formato fornito
      const dataCompilazione: Date = new Date(this._datiSurvey.dataCompilazione);

      // Ottenere i componenti della data
      const giorno: string = String(dataCompilazione.getDate()).padStart(2, '0');
      const mese: string = String(dataCompilazione.getMonth() + 1).padStart(2, '0'); // Mese inizia da 0
      const anno: number = dataCompilazione.getFullYear();

      // Formattare la data nel tuo formato desiderato
      this.dataCompilazione = `${giorno}/${mese}/${anno}`;
    }
  }

  private static readonly TIPO_ELEMENTO_VALORI = [
    'ENTITA',
    'PORTATA',
    'PROBABILITA',
    'IRRIMEDIABILITA',
    'SEVERITA',
    'PROBABILITA_RISCHI_OPPORTUNITA',
  ] as const;

  setInfoElemento(
    tipoElemento: (typeof AnteprimaDoppiaMaterialitaSuveyComponent.TIPO_ELEMENTO_VALORI)[number],
  ) {
    if (!AnteprimaDoppiaMaterialitaSuveyComponent.TIPO_ELEMENTO_VALORI.includes(tipoElemento)) {
      throw new Error(`Valore non valido per tipoElemento: ${tipoElemento}`);
    }

    switch (tipoElemento) {
      case 'ENTITA':
        this.infoElemento = this.setInfoEntita();
        break;
      case 'PORTATA':
        this.infoElemento = this.setInfoPortata();
        break;

      case 'PROBABILITA':
        this.infoElemento = this.setInfoProbabilita();
        break;
      case 'IRRIMEDIABILITA':
        this.infoElemento = this.setInfoIrrimediabilita();
        break;
      case 'SEVERITA':
        this.infoElemento = this.setInfoSeverita();
        break;
      case 'PROBABILITA_RISCHI_OPPORTUNITA':
        this.infoElemento = this.setInfoProbabilitaRischiOpportunita();
        break;

      default:
        break;
    }

    return this.infoElemento;
  }

  setInfoEntita() {
    const entitaTableHtml = `
    <table style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
      <thead>
        <tr style="background-color: #f2f2f2;">
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">VALORE</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">DESCRIZIONE</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">INFORMAZIONI AGGIUNTIVE</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">5</td>
          <td style="border: 1px solid #ddd; padding: 8px;">Grave</td>
          <td style="border: 1px solid #ddd; padding: 8px;">
            <strong>Impatto positivo</strong>: il beneficio è molto importante con un effetto e una scala molto elevati per le persone o l'ambiente<br>
            <strong>Impatto negativo</strong>: l'influenza negativa dell'impatto è molto importante, con un effetto e una portata molto elevati per le persone o l'ambiente (es. impatto ambientale molto grave con effetti che persistono o impatti sociali gravi e prolungati alla comunità)
          </td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">4</td>
          <td style="border: 1px solid #ddd; padding: 8px;">Critico</td>
          <td style="border: 1px solid #ddd; padding: 8px;">
            <strong>Impatto positivo</strong>: il beneficio ha un impatto elevato in termini di persone o ambiente<br>
            <strong>Impatto negativo</strong>: l'influenza negativa ha un impatto elevato in termini di persone o ambiente (es. impatti ambientali con effetti temporanei o impatti sociali che causano danni gravi e temporanei alla comunità)
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">3</td>
          <td style="border: 1px solid #ddd; padding: 8px;">Significativo</td>
          <td style="border: 1px solid #ddd; padding: 8px;">
            <strong>Impatto positivo</strong>: il beneficio ha un effetto medio sulle persone o sull'ambiente<br>
            <strong>Impatto negativo</strong>: l'influenza negativa ha un effetto medio sulle persone o sull'ambiente (es. impatti ambientali rilevanti con effetti temporanei o impatti sociali che causano danni rilevanti e temporanei alla comunità)
          </td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">2</td>
          <td style="border: 1px solid #ddd; padding: 8px;">Moderato</td>
          <td style="border: 1px solid #ddd; padding: 8px;">
            <strong>Impatto positivo</strong>: il beneficio ha luogo in modo minimo<br>
            <strong>Impatto negativo</strong>: l'influenza negativa dell'impatto si manifesta in modo lieve (es. impatti ambientali lievi con effetti temporanei o impatti sociali che causano danni lievi e temporanei alla comunità)
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">1</td>
          <td style="border: 1px solid #ddd; padding: 8px;">Trascurabile</td>
          <td style="border: 1px solid #ddd; padding: 8px;">
            <strong>Impatto positivo</strong>: il beneficio ha luogo in modo trascurabile<br>
            <strong>Impatto negativo</strong>: l'influenza negativa dell'impatto si manifesta in modo trascurabile (es. impatti ambientali trascurabili con effetti temporanei o impatti sociali che causano danni trascurabili e temporanei alla comunità)
          </td>
        </tr>
      </tbody>
    </table>
    `;

    return entitaTableHtml;
  }

  setInfoPortata() {
    const portataTableHtml: string = `
    <table style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
      <thead>
        <tr style="background-color: #f2f2f2;">
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">VALORE</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">DESCRIZIONE</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>5</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">
            <strong>Impatto positivo</strong>: il beneficio riguarda un numero molto elevato di persone a livello globale, ha una portata globale o causa un grande contributo ambientale<br>
            <strong>Impatto negativo</strong>: l'influenza negativa riguarda un numero elevato di persone a livello globale, ha una portata globale o causa un grande danno ambientale (es. impatti ambientali su aree molto estese o impatti sociali su aree molto estese)
          </td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>4</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">
            <strong>Impatto positivo</strong>: il beneficio impatta favorevolmente su una vasta popolazione, si estende su larga area geografica (ambito continentale) o comporta un significativo miglioramento per l'ambiente<br>
            <strong>Impatto negativo</strong>: Un impatto negativo che colpisce un'ampia fascia di individui, si propaga su un'estesa area geografica (ambito continentale) o determina un degrado ambientale
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>3</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">
            <strong>Impatto positivo</strong>: il beneficio si estende ad un gruppo specifico di individui, esercita un'influenza su un'area geografica di estensione moderata (ambito nazionale) o promuove un contributo significativo alla salvaguardia dell'ambiente<br>
            <strong>Impatto negativo</strong>: l'effetto negativo si manifesta su un numero limitato di persone, ha ripercussioni su una zona geografica di dimensioni intermedie (ambito nazionale) o incide negativamente sul benessere ambientale
          </td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>2</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">
            <strong>Impatto positivo</strong>: il beneficio è circoscritto a un gruppo specifico di persone o a un ambito geografico ristretto (ambito regionale o provinciale), e si manifesta attraverso un contributo ambientale mirato o di piccola entità<br>
            <strong>Impatto negativo</strong>: gli impatti negativi sono circoscritti a un ristretto gruppo di individui, a un ambito delimitato (ambito regionale) e comportano un modesto danno ambientale
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>1</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">
            <strong>Impatto positivo</strong>: il beneficio è circoscritto a un gruppo specifico di persone o a un ambito ristretto (ambito cittadino), e si manifesta attraverso un contributo ambientale mirato o di piccola entità<br>
            <strong>Impatto negativo</strong>: gli impatti negativi sono circoscritti a un ristretto gruppo di individui, a un ambito geografico cittadino e comportano un modesto danno ambientale.
          </td>
        </tr>
      </tbody>
    </table>
    `;
    return portataTableHtml;
  }

  setInfoProbabilita() {
    const probabilitaTableHtml = `
    <table style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
      <thead>
        <tr style="background-color: #f2f2f2;">
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">VALORE</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">RATING</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">DESCRIZIONE</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>5</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
            <div>Molto alta</div>
            <div style="margin-top: 5px;">>85%</div>
          </td>
          <td style="border: 1px solid #ddd; padding: 8px;">È quasi sicuro che il beneficio/impatto negativo si verifichi frequentemente</td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>4</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
            <div>Alta</div>
            <div style="margin-top: 5px;">60 - 85%</div>
          </td>
          <td style="border: 1px solid #ddd; padding: 8px;">È possibile che il beneficio/impatto negativo si verifichi nell'arco temporale di circa 1 anno</td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>3</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
            <div>Media</div>
            <div style="margin-top: 5px;">40 - 60%</div>
          </td>
          <td style="border: 1px solid #ddd; padding: 8px;">È possibile che il beneficio/impatto negativo si verifichi nell'arco temporale di circa 3 anni</td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>2</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
            <div>Bassa</div>
            <div style="margin-top: 5px;">15 - 40%</div>
          </td>
          <td style="border: 1px solid #ddd; padding: 8px;">È possibile che il beneficio/impatto negativo si verifichi nell'arco temporale di circa 5 anni</td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>1</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
            <div>Molto bassa</div>
            <div style="margin-top: 5px;"><15%</div>
          </td>
          <td style="border: 1px solid #ddd; padding: 8px;">È improbabile che il beneficio/impatto negativo si verifichi e non si è verificato mai o quasi mai</td>
        </tr>
      </tbody>
    </table>
    `;
    return probabilitaTableHtml;
  }

  setInfoIrrimediabilita() {
    const irrimediabilitaTableHtml = `
    <table style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
      <thead>
        <tr style="background-color: #f2f2f2;">
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">VALORE</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">DESCRIZIONE</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>5</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">L'impatto non può essere compensato, mitigato o risolto</td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>4</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">Rimediare all'impatto è molto difficile o è necessario un processo lungo (> 5 anni)</td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>3</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">L'impatto è rimediabile nel breve termine (3-5 anni) ed è necessario uno sforzo in termini di costi</td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>2</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">L'impatto è rimediabile anche nel breve termine (un anno) ed è necessario uno sforzo medio in termini di costi</td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>1</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">L'impatto è facile da contrastare e rimediare al danno che ne deriva</td>
        </tr>
      </tbody>
    </table>
    `;
    return irrimediabilitaTableHtml;
  }

  setInfoSeverita() {
    const severitaTableHtml = `
    <table style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
      <thead>
        <tr style="background-color: #f2f2f2;">
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">VALORE</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">DESCRIZIONE</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">% DEL FATTURATO</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>5</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">Grave, a tal punto da mettere in pericolo l'esistenza dell'azienda</td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">>10%</td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>4</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">Critico</td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">5-10%</td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>3</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">Significativo</td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">2-5%</td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>2</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">Moderato</td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">1-2%</td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>1</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px;">Trascurabile</td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><1%</td>
        </tr>
      </tbody>
    </table>
    `;
    return severitaTableHtml;
  }

  setInfoProbabilitaRischiOpportunita() {
    const probabilitaRischiOpportunitaTableHtml = `
    <table style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
      <thead>
        <tr style="background-color: #f2f2f2;">
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">VALORE</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">RATING</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">DESCRIZIONE</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>5</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
            <div>Molto alta</div>
            <div style="margin-top: 5px;">>85%</div>
          </td>
          <td style="border: 1px solid #ddd; padding: 8px;">È quasi sicuro che il rischio/opportunità si verifichi frequentemente</td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>4</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
            <div>Alta</div>
            <div style="margin-top: 5px;">60 - 85%</div>
          </td>
          <td style="border: 1px solid #ddd; padding: 8px;">È possibile che il rischio/opportunità si verifichi nell'arco temporale di circa 1 anno</td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>3</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
            <div>Media</div>
            <div style="margin-top: 5px;">40 - 60%</div>
          </td>
          <td style="border: 1px solid #ddd; padding: 8px;">È possibile che il rischio/opportunità si verifichi nell'arco temporale di circa 3 anni</td>
        </tr>
        <tr style="background-color: #f9f9f9;">
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>2</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
            <div>Bassa</div>
            <div style="margin-top: 5px;">15 - 40%</div>
          </td>
          <td style="border: 1px solid #ddd; padding: 8px;">È possibile che il rischio/opportunità si verifichi nell'arco temporale di circa 5 anni</td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"><strong>1</strong></td>
          <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
            <div>Molto bassa</div>
            <div style="margin-top: 5px;"><15%</div>
          </td>
          <td style="border: 1px solid #ddd; padding: 8px;">È improbabile che il rischio/opportunità si verifichi e non si è verificato mai o quasi mai</td>
        </tr>
      </tbody>
    </table>
    `;
    return probabilitaRischiOpportunitaTableHtml;
  }
}
